import Grid from "@mui/material/Grid";
import React from "react";
import RulesTable from "../../components/rulesTable/RulesTable";
import { useCallback,useEffect,useState } from "react";
import "./AnalyticsDashboard.css";
import OrdersOverview from "../../components/orderOverview/OrderOverview";
import AnalyticsTile from "../../components/analyticsTile/analyticsTile";
import { getRulesTable, getServerList } from "../../services/integrationService";
import { Button} from "@mui/material";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";


export function AnalyticsDashboard() {
   const lob = localStorage.getItem('lob');
   const { translate } = usePortalTranslation();
   const CUR_COMPONENT_COMMON="commonPortal";
    const [serverData, setServerData] = useState<any[]>([]);
    const [rulesData, setRulesData] = useState<any[]>([]);
    const headers: string[] = ['CATEGORY', 'NAME', 'STATUS','LAST UPDATED','DESCRIPTION'];
    const handleBackClick = () => {
      window.history.back();
    };
    const fetchServerList = useCallback(async () => {
          const data = await getServerList();
          
          setServerData(data);
      }, []);
      const fetchRulesTable = useCallback(async () => {
        if(lob){
          const data = await getRulesTable(lob);
          const rules = data.data.monitorDetails.rules
          
          setRulesData(rules);
        }

       
    }, []);


      useEffect(()=>{

        fetchServerList()
        fetchRulesTable();
      },[fetchServerList, fetchRulesTable]);
  return (
    <>
    
    <div className="box-container">
        <div className="tile-container" style={{display:"flex",justifyContent:"space-between",gap:"10px"}}>
          {/* <Grid container spacing="2px"> */}
            <div style={{display:"flex",width:"95%",gap:"30px",flexWrap:"wrap"}}>
              {serverData.map((item, index) => (
                <Grid item key={index} xs={3} md={4} lg={2} sm={6}>
                  <AnalyticsTile heading={item.name} status={item.status} />
                </Grid>
              ))}
            </div>
            <div>
              {/* <Grid item xs={12} sx={{ position: "absolute", right: "80px", top: "150px", color: "white"}}> */}
              <Button variant="contained" color="primary" onClick={handleBackClick} style={{ color: "white", backgroundColor: "#24c6b1", fontWeight: "bold" }}>
                {translate(TranslationEnum.common_portal, "BACK")}
              </Button>
              {/* </Grid> */}
            </div>    
        {/* </Grid> */}
        </div>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={8}>
            <RulesTable data={rulesData} headers={headers}/>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <OrdersOverview />
          </Grid>
        </Grid>
        
     
    </div>
    </>
  );
}
